  <div class="lecteurs-list-container">
    <div class="lecteurs-list-title">
      <h1>Mes appareils</h1>
      <small>Liste des appareils enregistrés dans votre espace de travail. Pour utiliser votre lecteur sur cet appareil, vous pouvez enregistrer ce dernier sur cette page.</small>
    </div>
    <div class="lecteurs-list-body">
      <ng-container *ngFor="let terminal of listTerminals">
        <lua-divider-horizontal size="small"></lua-divider-horizontal>
        <di-objet-lecteur
          [terminal]="terminal"
          [cetAppareil]="terminal.isCurrentDevice"
          (click)="openPanneauAjoutAppareil(terminal)"
        ></di-objet-lecteur>
      </ng-container>
      <lua-divider-horizontal size="small"></lua-divider-horizontal>
      <lua-action-secondaire class="button-ajout-appareil" *ngIf="deviceType !== 'IOS' && deviceType !== 'ANDROID'" libelle="Ajouter cet appareil" (click)="openPanneauAjoutAppareil()" [fullWidth]="false"></lua-action-secondaire>
    </div>
    <lua-bouton-floating *ngIf="deviceType === 'IOS' || deviceType === 'ANDROID'" iconName="add" right="30px" bottom="30px" (onClick)="handleShowMenu()"></lua-bouton-floating>
    <lua-overlay *ngIf="showMenu" (onClick)="handleCloseMenu()" class="overlay_menu">
      <div class="menu-buttons-container">
          <div (click)="openPanneauAjoutAppareil()" class="button-wrapper">
            <lua-bouton-icone [isDisabled]="deviceIdRegistered" iconName="devices"></lua-bouton-icone>
            <p class="button-label">Ajouter cet appareil</p>
          </div>
          <div (click)="openPanneauConnecterLecteur()" class="button-wrapper">
            <lua-bouton-icone [isDisabled]="!deviceIdRegistered" iconName="smart_card_reader"></lua-bouton-icone>
            <p class="button-label">Connecter un lecteur</p>
          </div>
					<div (click)="openPanneauEcouterAppareil()" class="button-wrapper">
            <lua-bouton-icone [isDisabled]="!deviceIdRegistered" iconName="cast_connected"></lua-bouton-icone>
            <p  class="button-label">Diagnostique de mon appareil</p>
          </div>
      </div>
    </lua-overlay>
  </div>